import Qualities from './Qualities';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';
import lifecycle from 'recompose/lifecycle';
import chunk from 'lodash/chunk';
import has from 'lodash/has';
import debounce from 'lodash/debounce';
import { withFormik } from 'formik';
import withValidationData from '../../../hocs/withValidationData';
import { validateCreationForm, clearErrors } from '../helpers';
import { getMaxLength } from './helpers';

import {
  trackQualitiesDrawerSelected,
  trackQualitiesDrawerErrored,
  trackQualitiesDrawerOpenTab,
  trackQualitiesDrawerCloseTab
} from 'src/client/js/analytics/category/product';

const debouncedValidation = debounce(
  (values, props, config) => validateCreationForm(values, props, config),
  700
);

const enhance = compose(
  withValidationData,
  withProps(({ drawer: { customisationKey = 'values' } }) => ({
    customisationKey,
  })),
  withFormik({
    mapPropsToValues: ({ customisationKey, queryParams, productCustomisation }) => ({
      base: '',
      [customisationKey]: queryParams[customisationKey] || productCustomisation[customisationKey] || [],
    }),
    handleSubmit: (values, { props }) => {
      props.onFormikSubmit(values);
    },
  }),
  withProps(props => ({
    columns: chunk(props.drawer.items, 3),
  })),
  withHandlers({
    handleChange: ({ customisationKey, values, ...props }) => e => {
      let options = values[customisationKey].concat();

      const value = e.target.value;
      const valueIndex = options.indexOf(value);

      if (valueIndex !== -1) {
        options.splice(valueIndex, 1);
      } else {
        options.push(value);
      }

      if (options.length >= getMaxLength(props)) {
        clearErrors(props, customisationKey);
        props.setSubmitting(true);
        debouncedValidation({ [customisationKey]: options }, props, { enableSetErrors: true });
      }

      trackQualitiesDrawerSelected(value, valueIndex !== -1);
      props.setFieldValue(customisationKey, options);
    }
  }),
  lifecycle({
    componentDidMount() {
      trackQualitiesDrawerOpenTab();
    },
    componentDidUpdate() {
      const { errors, customisationKey, values } = this.props;

      if (has(errors, customisationKey)) {
        trackQualitiesDrawerErrored(values[customisationKey].length);
      }
    },
    componentWillUnmount() {
      trackQualitiesDrawerCloseTab();
    }
  })
);

export default enhance(Qualities);
